import { JobsStateJobFragment } from '@shared/contexts/pluginContexts/EmailThreadContext';
import {
  JobSummaryFragment,
  OptimismStatus,
  ProcessingStatus,
  QuoteSummaryFragment,
} from '@shared/generated/graphql';

export const filterJobsWithNoConfirmedEntities = (
  jobs: JobSummaryFragment[]
) => {
  return jobs.filter((job) => {
    const quotesToShow = job?.quotes.filter(
      (quote) => quote?.optimismStatus !== OptimismStatus.OPTIMISTIC
    );
    const ordersToShow = job?.orders.filter(
      (order) => order?.optimismStatus !== OptimismStatus.OPTIMISTIC
    );

    // TODO(parlato): We should change this - if the job failed,
    // we should show a link to the job in the web app perhaps. Or
    // at least an error with the job ID.
    const jobIsProcessing = job?.status !== ProcessingStatus.COMPLETED;
    const jobIsOptimistic = job.optimismStatus === OptimismStatus.OPTIMISTIC;
    return (
      quotesToShow.length > 0 ||
      ordersToShow.length > 0 ||
      (!jobIsOptimistic && jobIsProcessing)
    );
  });
};

export const filterJobsToDisplay = (jobs: JobSummaryFragment[]) => {
  return filterJobsWithNoConfirmedEntities(jobs);
};

export const jobFragmentsToJobsState = (data: any): JobsStateJobFragment[] => {
  const jobs = data?.jobs.edges.map((edge: any) => ({
    ...edge.node,
    quotes: [
      ...edge.node.quotes,
      ...edge.node.relatedCanonicalQuotes.map((q: QuoteSummaryFragment) => ({
        ...q,
        isRelatedCanonicalQuote: true,
      })),
    ],
  }));
  if (!jobs) return [];
  return filterJobsToDisplay(jobs);
};

export const getHasUnconfirmedQuoteAndOrder = (
  data: any
): { hasUnconfirmedQuote: boolean; hasUnconfirmedOrder: boolean } => {
  const jobNodes = data?.jobs.edges.map((edge: any) => edge.node);

  if (!jobNodes?.length)
    return { hasUnconfirmedQuote: false, hasUnconfirmedOrder: false };

  return {
    hasUnconfirmedQuote: jobNodes.some((node: any) =>
      (node.quotes || []).some(
        (quote: any) => quote.optimismStatus === OptimismStatus.OPTIMISTIC
      )
    ),
    hasUnconfirmedOrder: jobNodes.some((node: any) =>
      (node.orders || []).some(
        (order: any) => order.optimismStatus === OptimismStatus.OPTIMISTIC
      )
    ),
  };
};
